export default __webpack_public_path__ + "locales/sk/UploadPanel.json?hash=94f285e1f9de2bfb39506cf139a89efe";